import React from 'react';
import { motion } from 'framer-motion';

const Logo = ({ size = 40 }) => {
  const circuitVariants = {
    animate: {
      pathLength: [0, 1, 0],
      opacity: [0.3, 1, 0.3],
      transition: {
        duration: 3,
        repeat: Infinity,
        ease: "easeInOut"
      }
    }
  };

  const nodeVariants = {
    animate: {
      scale: [1, 1.2, 1],
      opacity: [0.7, 1, 0.7],
      transition: {
        duration: 2,
        repeat: Infinity,
        ease: "easeInOut",
        staggerChildren: 0.2
      }
    }
  };

  return (
    <motion.svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      whileHover={{ scale: 1.1 }}
      transition={{ duration: 0.3 }}
    >
      <defs>
        <linearGradient id="brainGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#4F46E5" />
          <stop offset="50%" stopColor="#7C3AED" />
          <stop offset="100%" stopColor="#EC4899" />
        </linearGradient>
        <linearGradient id="circuitGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#10B981" />
          <stop offset="100%" stopColor="#3B82F6" />
        </linearGradient>
      </defs>
      
      {/* Brain outline */}
      <motion.path
        d="M32 8C20 8 12 16 12 28C12 32 14 36 16 38C14 40 12 44 12 48C12 52 16 56 22 56C26 56 30 54 32 52C34 54 38 56 42 56C48 56 52 52 52 48C52 44 50 40 48 38C50 36 52 32 52 28C52 16 44 8 32 8Z"
        fill="url(#brainGradient)"
        stroke="currentColor"
        strokeWidth="1"
        className="text-gray-800 dark:text-gray-200"
        initial={{ pathLength: 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration: 2, ease: "easeInOut" }}
      />
      
      {/* Neural nodes */}
      <motion.g variants={nodeVariants} animate="animate">
        <motion.circle cx="20" cy="24" r="2" fill="url(#circuitGradient)" variants={nodeVariants} />
        <motion.circle cx="32" cy="20" r="2" fill="url(#circuitGradient)" variants={nodeVariants} />
        <motion.circle cx="44" cy="24" r="2" fill="url(#circuitGradient)" variants={nodeVariants} />
        <motion.circle cx="24" cy="32" r="2" fill="url(#circuitGradient)" variants={nodeVariants} />
        <motion.circle cx="40" cy="32" r="2" fill="url(#circuitGradient)" variants={nodeVariants} />
        <motion.circle cx="28" cy="40" r="2" fill="url(#circuitGradient)" variants={nodeVariants} />
        <motion.circle cx="36" cy="40" r="2" fill="url(#circuitGradient)" variants={nodeVariants} />
      </motion.g>
      
      {/* Connection lines */}
      <motion.g>
        <motion.line
          x1="20" y1="24" x2="32" y2="20"
          stroke="url(#circuitGradient)"
          strokeWidth="1.5"
          variants={circuitVariants}
          animate="animate"
        />
        <motion.line
          x1="32" y1="20" x2="44" y2="24"
          stroke="url(#circuitGradient)"
          strokeWidth="1.5"
          variants={circuitVariants}
          animate="animate"
        />
        <motion.line
          x1="20" y1="24" x2="24" y2="32"
          stroke="url(#circuitGradient)"
          strokeWidth="1.5"
          variants={circuitVariants}
          animate="animate"
        />
        <motion.line
          x1="44" y1="24" x2="40" y2="32"
          stroke="url(#circuitGradient)"
          strokeWidth="1.5"
          variants={circuitVariants}
          animate="animate"
        />
        <motion.line
          x1="24" y1="32" x2="28" y2="40"
          stroke="url(#circuitGradient)"
          strokeWidth="1.5"
          variants={circuitVariants}
          animate="animate"
        />
        <motion.line
          x1="40" y1="32" x2="36" y2="40"
          stroke="url(#circuitGradient)"
          strokeWidth="1.5"
          variants={circuitVariants}
          animate="animate"
        />
        <motion.line
          x1="28" y1="40" x2="36" y2="40"
          stroke="url(#circuitGradient)"
          strokeWidth="1.5"
          variants={circuitVariants}
          animate="animate"
        />
      </motion.g>
    </motion.svg>
  );
};

export default Logo;